
import { getDateFormate } from "../../Common/AllDateTimeReleventFormate";
import { useNavigate } from "react-router-dom";
import { useRouteBaseStateContext } from "../../../Context/RouteBaseStateContext";
import CloudStorage from "../../../CloudStorage/CloudStorage";

export default function ModalMilestoneDetails({ data }) {
  const laung = localStorage.getItem("laung");
  const navigate = useNavigate();
  const { setMyorderActiveprojectroute } = useRouteBaseStateContext();
  return (
    <div className="post-modal-details">
      <div className="post-back">
        <div className="col-md-12 ">
          <h3>Milestone Details </h3>
          <p> {data?.title} </p>
          {/* <p> <GetRemainDays enddate={data?.ends_on} />  </p> */}
          <p>Due on</p>
          <p>{getDateFormate(data?.ends_on)} </p>
        </div>
      </div>
      <button
        onClick={() => {
          navigate(`/${laung ?? "en"}/dashboard/myorders/project/active/${data.post_id}`);
          setMyorderActiveprojectroute("Milestones");
        }}
        className="btn buttons border-button ml-auto mt-3"
      >
        {" "}
        Review works
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
          alt=""
        />
      </button>
    </div>
  );
}
